import React from "react";
import AsyncSelect from "react-select/async";
import apiClient from "../services/api";
import { colors } from "../theme"; // Import colors from centralized theme

const buildStyles = (controlBackground) => {
  const bg = controlBackground || colors.background;
  return {
    control: (base, state) => ({
      ...base,
      backgroundColor: bg,
      borderColor: state.isFocused ? colors.primary : colors.border,
      color: colors.textPrimary,
      borderRadius: "0.375rem",
      padding: "2px",
      fontSize: "0.875rem",
      boxShadow: "none",
      '&:hover': {
        borderColor: colors.primary,
      },
    }),
    input: (base) => ({
      ...base,
      color: colors.textPrimary,
    }),
    menu: (base) => ({
      ...base,
      backgroundColor: bg,
      color: colors.textPrimary,
      zIndex: 9999,
    }),
    menuPortal: (base) => ({
      ...base,
      zIndex: 9999,
    }),
    option: (base, state) => ({
      ...base,
      backgroundColor: state.isFocused ? colors.primaryActive : bg,
      color: state.isFocused ? colors.primary : colors.textPrimary,
      cursor: "pointer",
    }),
    multiValue: (base) => ({
      ...base,
      backgroundColor: colors.primary,
      borderRadius: "0.25rem",
    }),
    multiValueLabel: (base) => ({
      ...base,
      color: colors.textPrimary,
      fontWeight: "500",
    }),
    multiValueRemove: (base) => ({
      ...base,
      color: colors.textPrimary,
      ':hover': {
        backgroundColor: colors.primaryDark,
        color: colors.textPrimary,
      },
    }),
    placeholder: (base) => ({
      ...base,
      color: '#ffffff',
    }),
  };
};

const MultiSelectTicker = ({ onChange, value, placeholder = "Search and select tickers...", controlBackground }) => {
  const styles = React.useMemo(() => buildStyles(controlBackground), [controlBackground]);
  const loadOptions = async (inputValue) => {
    if (!inputValue) return [];

    try {
      // Use apiClient instead of fetch to ensure correct API URL in production
      const response = await apiClient.get('/ticker-search/', {
        params: { search: inputValue }
      });

      const data = response.data;
      if (!data || data.length === 0) {
        return [{ label: "No results found", value: "" }];
      }

      return data.map((item) => ({
        label: `${item.code} — ${item.name}`,
        value: item.code,
      }));
    } catch (error) {
      console.error("Error loading tickers:", error);
      return [{ label: "Error loading tickers", value: "" }];
    }
  };

  return (
    <AsyncSelect
      isMulti
      cacheOptions
      loadOptions={loadOptions}
      defaultOptions
      onChange={onChange}
      value={value}
      placeholder={placeholder}
      isClearable
      styles={styles}
      closeMenuOnSelect={false}
      menuPortalTarget={document.body}
      menuPosition="fixed"
    />
  );
};

export default MultiSelectTicker;